export default __webpack_public_path__ + "static/media/theme-atoms.5eaa99ac.png";